export default __webpack_public_path__ + "static/media/home-active.920c7c25.svg";